import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  downloadMultipleFiles,
  formatBytes,
  getFileExtension,
  saveFile,
} from "../Utils";

function CompressFilesImagesListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //set zipped filename
  const [zippedFileName, setZippedFileName] = useState("zipped_files");
  useState(null);
  //is zipping
  const [isZipping, setIsZipping] = useState(false);

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //process files
      processFiles();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const processFiles = async () => {
    //loop
    //read files
    for (let i = 0; i < selectedFiles.length; i++) {
      //selected file
      const selectedFile = selectedFiles[i];
      //path pdf file
      const key = String(selectedFile.path);
      //set image
      setFilesInfo((prevDictionary) => ({
        ...prevDictionary,
        [key]: {
          ...filesInfo[key],
          state: AppState.LOADED,
          thumbnail: null,
          message: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
        },
      }));
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //on  filename value changed
  const onFilenameValueChanged = (e) => {
    //set values
    setZippedFileName(e.target.value);
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div className="mt-3" key={index} style={{ cursor: "pointer" }}>
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size:{" "}
                {String(item.path) in filesInfo
                  ? formatBytes(item.size)
                  : formatBytes(0)}
              </div>
            </div>

            {/* file type */}
            <div className={`mt-2 ms-2 my-auto`}>
              <label
                className={`px-2 rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "COMPRESSED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </label>
            </div>

            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Download Button */}
          {/* Show download button after processed */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* page main content */}
      <div>
        {/* Top bar */}
        <div className="bg-light border-bottom my-auto sticky-top">
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-transparent"
              onClick={resetScreen}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="#000000"
                className="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </button>
            {/* Title */}
            <label className="fs-3 ms-2 py-2 text-secondary fs-4">
              {props.title ?? "Compress files"}
            </label>
          </div>
        </div>

        {/*Container left list & right controls */}
        <div
          className="d-flex"
          style={{
            height: "calc(100vh - 52px)",
            maxHeight: "calc(100vh - 52px)",
          }}
        >
          {/* Left List */}
          <div
            className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
            style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
          >
            {renderFilesListView()}
          </div>

          {/* Right controls */}
          <div
            className="ms-sm-5 ms-1  border-start position-relative"
            style={{
              marginBottom: "100px", //add space to bottom for button, else overlap
              width: "25%",
              maxWidth: "25%",
              overflowY: "auto",
              minWidth: "200px",
            }}
          >
            {/* Label filename input */}
            <div>
              <label
                htmlFor="zippedFilename"
                className="form-label mt-5 ms-4 fs-4 text-dark"
                data-toggle="tooltip"
                data-placement="top"
                title="Output filename"
              >
                Output filename:
              </label>
              <input
                type="text"
                className="form-control ms-4 mt-3 me-4"
                id="zippedFilename"
                aria-describedby="zippedFilename"
                placeholder="Output filename (xyz)"
                onChange={onFilenameValueChanged}
                style={{ width: "calc(100% - 48px)" }}
              />
            </div>

            {/* Info */}
            <div className="mt-5 ms-4">
              <label
                className="form-label fs-4 text-dark"
                data-toggle="tooltip"
                data-placement="top"
                title="Output information"
              >
                Information:
              </label>

              {/* Total size */}
              <div className="d-flex mt-2">
                {" "}
                <label className="fs-6 text-secondary">Total Size:</label>
                <label className="ms-2 fs-6 text-secondary">
                  {formatBytes(
                    selectedFiles.reduce((previousScore, item) => {
                      return previousScore + item.size;
                    }, 0),
                  )}
                </label>
              </div>

              {/* File count */}
              <div className="d-flex">
                {" "}
                <label className="fs-6 text-secondary">File Count:</label>
                <label className="ms-2 fs-6 text-secondary">
                  {selectedFiles.length} Files
                </label>
              </div>
            </div>

            {/* Convert Button */}
            <button
              className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                isZipping ? "disabled" : ""
              }`}
              style={{
                marginLeft: "10px",
                width:
                  window !== undefined
                    ? window.innerWidth * 0.25 < 200
                      ? "180px"
                      : window.innerWidth * 0.25 - 40
                    : "180px",
                bottom: "10px",
              }}
              type="button"
              onClick={async (e) => {
                //set
                setIsZipping(true);

                //check
                if (selectedFiles.length === 0) {
                  //return
                  return;
                }

                //loop
                //set status
                for (let i = 0; i < selectedFiles.length; i++) {
                  //selected file
                  const selectedFile = selectedFiles[i];
                  //path pdf file
                  const key = String(selectedFile.path);
                  //set state
                  setFilesInfo((prevDictionary) => ({
                    ...prevDictionary,
                    [key]: {
                      ...filesInfo[key],
                      state: AppState.PROCESSING,
                      message: `Zipping file...`,
                    },
                  }));
                }

                //download zipped file
                const zippedBlob = await downloadMultipleFiles(
                  selectedFiles,
                  zippedFileName,
                  "DEFLATE",
                );

                //loop
                //set status
                for (let i = 0; i < selectedFiles.length; i++) {
                  //selected file
                  const selectedFile = selectedFiles[i];
                  //path pdf file
                  const key = String(selectedFile.path);
                  //set state
                  setFilesInfo((prevDictionary) => ({
                    ...prevDictionary,
                    [key]: {
                      ...filesInfo[key],
                      state: AppState.PROCESSED,
                      message: `Successfully zipped selected files. Zipped (.zip) file will be downloaded automatically on your device.`,
                    },
                  }));
                }

                //download zip
                saveFile(zippedBlob, zippedFileName + ".zip");
                //reset
                setIsZipping(false);
              }}
            >
              Zip Files
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompressFilesImagesListScreen;
